import { CommonModule } from '@angular/common';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'header-govbr',
    templateUrl: './header-gov-br.component.html',
    styleUrls: ['./header-gov-br.component.scss'],
    standalone: true,
    imports:[CommonModule]
})
export class HeaderGovBrComponent implements OnInit {
  isActive = false;
  private isContrastEnabled = false;
  private fontSize = 100; // Tamanho inicial da fonte em %
  periodoEleitoral: boolean = environment.periodoEleitoral;
  
  constructor(
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    // Primeiro verifica se há uma preferência salva no localStorage
    const savedContrast = localStorage.getItem('contrastEnabled');

    if (savedContrast !== null) {
      // Se já existe uma preferência salva, use-a
      this.isContrastEnabled = savedContrast === 'true';
    } else {
      // Caso contrário, detecte a preferência do sistema
      this.isContrastEnabled = window.matchMedia('(prefers-color-scheme: dark)').matches;
      // Salva a preferência detectada
      localStorage.setItem('contrastEnabled', this.isContrastEnabled.toString());
    }

    // Aplica o contraste inicial com base no estado determinado
    this.applyContrast();

    // Adiciona um listener para mudanças na preferência do sistema
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
      // Só aplica automaticamente se o usuário não tiver definido manualmente
      // ou se for a primeira vez (não há registro no localStorage)
      if (localStorage.getItem('userDefinedContrast') !== 'true') {
        this.isContrastEnabled = e.matches;
        this.applyContrast();
        localStorage.setItem('contrastEnabled', this.isContrastEnabled.toString());
      }
    });
  }

  toggleContrast(): void {
    this.isContrastEnabled = !this.isContrastEnabled; // Atualiza o estado
    this.applyContrast();

    // Salva o estado do contraste no localStorage
    localStorage.setItem('contrastEnabled', this.isContrastEnabled.toString());
    // Marca que o usuário definiu manualmente o contraste
    localStorage.setItem('userDefinedContrast', 'true');
  }

  // Método para aplicar o contraste
  private applyContrast(): void {
    const body = document.body;

    if (this.isContrastEnabled) {
      this.renderer.setAttribute(body, 'id', 'contrast');
    } else {
      this.renderer.removeAttribute(body, 'id');
    }
  }

  toggleActive() {
    this.isActive = !this.isActive;
  }

  increaseFontSize(): void {
    if (this.fontSize < 180) { // Limite máximo de 180%
      this.fontSize += 10;
      this.applyFontSizeToBody();
    }
  }

  decreaseFontSize(): void {
    if (this.fontSize > 100) { // Limite mínimo de 100%
      this.fontSize -= 10;
      this.applyFontSizeToBody();
    }
  }

  private applyFontSizeToBody(): void {
    const body = document.body;
    this.renderer.setStyle(body, 'zoom', `${this.fontSize}%`);
  }

  // Método para verificar e reaplicar o contraste após mudanças no DOM
  public reapplyContrastIfNeeded(): void {
    if (this.isContrastEnabled) {
      const body = document.body;
      this.renderer.setAttribute(body, 'id', 'contrast');
    }
  }

  // Método para resetar a preferência manual e usar apenas a do sistema
  public resetToSystemPreference(): void {
    localStorage.removeItem('userDefinedContrast');
    this.isContrastEnabled = window.matchMedia('(prefers-color-scheme: dark)').matches;
    this.applyContrast();
    localStorage.setItem('contrastEnabled', this.isContrastEnabled.toString());
  }
}
